import { FieldErrorMap } from "hooks/useFieldErrors";
import i18n from "locales/i18n";
import { checkRequired, validatePhoneNumber } from "pages/formTools";
import { Account } from "../..";

// Resolves the language per call, so messages follow the switcher.
const ta = i18n.getFixedT(null, "auth");

export const validateAddress = (data: Account): FieldErrorMap => ({
  // A placeId is only set when the user picks a Google suggestion, so its
  // absence means the address was free-typed (or edited after picking).
  address:
    checkRequired(ta("fields.address"), data.address) ??
    (data.placeId ? null : ta("fields.address_suggestion")),

  phoneNumber: validatePhoneNumber({
    name: ta("fields.phone"),
    value: data.phoneNumber,
    required: true,
  }),
});
